import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { EPlaybackState } from '@bufferController/PlaybackStateController/IPlaybackStateController';
import { IResolution } from '@resolutionsManager/IResolutionsManager';

export enum ELifecycleEvent {
  MANIFEST_LOADED = 'ManifestLoaded',
  FIRST_MEDIA_PLAYLIST_LOADED = 'FirstMediaPlaylistLoaded',
  FIRST_FRAGMENT_LOADED = 'FirstFragmentLoaded',
  FIRST_FRAGMENT_BUFFERED = 'FirstFragmentBuffered',
}

export enum ELifecycleError {
  MANIFEST_LOAD_ERROR = 'ManifestLoadError',
  PLAYLIST_LOAD_ERROR = 'PlaylistLoadError',
  FRAGMENT_LOAD_ERROR = 'FragmentLoadError',
}

export enum EEvent {
  VARIANTS_DETECTED = 'variantDetected',
  RESOLUTION_CHANGED = 'resolutionChanged',
  METRICS_AVAILABLE = 'metricsAvailable',
  ERROR = 'error',
  // Legacy events
  MANIFEST_LOADING = 'manifestLoading',
  MANIFEST_LOADED = 'manifestLoaded',
  MANIFEST_PARSED = 'manifestParsed',
  LEVEL_LOADED = 'levelLoaded',
  LEVEL_SWITCHED = 'levelSwitched',
  LEVEL_SWITCHED_AUTO = 'levelSwitchedAuto',
  LEVEL_SWITCHING = 'levelSwitching',
  MEDIA_ATTACHED = 'mediaAttached',
  MEDIA_DETACHED = 'mediaDetached',
  FRAG_LOADED = 'fragmentLoaded',
  LEVEL_METADATA_LOADED = 'levelMetadataLoaded',
  STREAM_STATE_TRANSITION = 'streamStateTransition',
  PLAYBACK_STATE_CHANGED = 'playbackStateChanged',
  FRAG_BUFFERED = 'fragBuffered',
  DEBUGGER_CONNECTED = 'debuggerConnected',
  STREAM_ENDED = 'streamEnded',
  LIFECYCLE_EVENT = 'lifecycleEvent',
  LIFECYCLE_ERROR = 'lifecycleError',
  FRAGMENT_FILTERED_OUT = 'fragmentFilteredOut',
  RESOLUTION_NOT_FOUND = 'resolutionNotFound',
}

export enum EErrorType {
  MEDIA_ERROR = 'mediaError',
  NETWORK_ERROR = 'networkError',
  PARSING_ERROR = 'parsingError',
}

export interface IErrorPayload {
  type: EErrorType;
  details?: string;
}

export interface IEventListener {
  [EEvent.VARIANTS_DETECTED]: (e: CustomEvent<Record<string, string>>) => void;
  [EEvent.METRICS_AVAILABLE]: (e: CustomEvent<IBufferMetrics>) => void;
  [EEvent.RESOLUTION_CHANGED]: (e: CustomEvent<IResolution>) => void;
  [EEvent.FRAGMENT_FILTERED_OUT]: (e: CustomEvent<{ reason: string }>) => void;
  [EEvent.ERROR]: (e: CustomEvent<IErrorPayload>) => void;
  [EEvent.DEBUGGER_CONNECTED]: (e: CustomEvent<{ panelUrl: string }>) => void;
  [EEvent.PLAYBACK_STATE_CHANGED]: (e: CustomEvent<{ prevState: EPlaybackState; nextState: EPlaybackState }>) => void;
  [EEvent.LIFECYCLE_EVENT]: (e: CustomEvent<{ eventType: ELifecycleEvent }>) => void;
  [EEvent.LIFECYCLE_ERROR]: (e: CustomEvent<{ errorType: ELifecycleError; nativeError: Error }>) => void;
}
